const Error = () => {
  return <h1>Error : 404 NOT FOUND</h1>;
};

export default Error;
